<template>
  <v-row>
    <v-col cols="12">
      <!-- fast state -->
      <v-card>
        <v-tabs background-color="background" color="primary" grow height="55" slider-size="4">
          <v-tab class="text-none font-weight-medium" to="/payments" exact>Todos los pagos</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/payments?status=succeeded" exact>Pagados</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/payments?status=requires_payment_method" exact>Incompletos</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/payments?status=failed" exact>Fallidos</v-tab>
        </v-tabs>
      </v-card>
      <!-- end fast state -->

      <v-card class="px-0 mt-5">
        <v-skeleton-loader v-if="$store.state.payments.retrieveLoader" transition="fade-transition" type="toolbar" />
        <v-toolbar v-else color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Pagos</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-table-settings resource="payments" />
              <v-query-builder :query-map="filters" model="payment" class="mr-1 ml-1" />
              <v-btn @click="dialogCreate=true" outlined color="secondary"><v-icon left small>mdi-plus</v-icon>Nuevo</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <payment-list />
        </v-card-text>
      </v-card>
    </v-col>

    <!-- dialog new payment -->
    <v-dialog v-model="dialogCreate" width="600" persistent no-click-animation>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Crear pago</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-1">
                <v-btn class="ml-3" @click="dialogCreate=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 background-card">
          <v-list class="v-list-form py-6 transparent">
            <v-list-item class="py-2">
              <v-list-item-title>Moneda</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="10">
                  <v-select v-model="newPayment.currency" :items="currencies.filter(c => !c.conversion)" item-value="id" item-text="name" label="Elige una moneda" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" background-color="white" height="30" outlined single-line dense hide-details>
                    <template v-slot:item="data">
                      <v-list-item-title>{{data.item.id}} - {{data.item.name}}</v-list-item-title>
                    </template>
                  </v-select>
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-2">
              <v-list-item-title>Monto</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="6">
                  <v-text-field v-model.number="$v.newPayment.amount.$model" :error="$v.newPayment.amount.$error" :suffix="newPayment.currency" background-color="white" outlined required single-line dense hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-2">
              <v-list-item-title>Descripción</v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field v-model="$v.newPayment.description.$model" :error="$v.newPayment.description.$error" background-color="white" outlined required single-line dense hide-details />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-2">
              <v-list-item-title>Fecha de pago</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="6">
                  <v-menu v-model="menu" :close-on-content-click="false" transition="slide-y-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="$v.newPayment.date.$model" :error="$v.newPayment.date.$error" v-bind="attrs" v-on="on" background-color="white" outlined single-line dense readonly hide-details>
                        <template v-slot:append>
                          <v-icon class="mr-3" small color="secondary">mdi-calendar</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="$v.newPayment.date.$model" @input="menu = false" type="date" :min="today" :first-day-of-week="1" locale="es-cl" width="280" color="primary" no-title>
                      <v-row class="py-2 px-6" align="center" justify="end">
                        <v-btn @click="() => { $v.newPayment.date.$model=today; menu=false }" color="primary">Hoy</v-btn>
                      </v-row>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-2 mt-4">
              <v-list-item-title>
                <v-btn @click="collapsePayment=!collapsePayment" text color="primary" :ripple="false">Más opciones<v-icon right>mdi-chevron-down</v-icon></v-btn>
              </v-list-item-title>
            </v-list-item>
            <template v-if="collapsePayment">
              <v-list-item three-line class="mt-n4">
                <v-list-item-title>Cliente</v-list-item-title>
                <v-list-item-subtitle class="py-1" v-if="!newPayment.customer.id">
                  <v-btn @click="dialogCustomer=true" outlined :ripple="false"><v-icon left>mdi-plus</v-icon>Seleccionar un cliente</v-btn>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-else>
                  <v-list class="transparent">
                    <v-list-item class="pa-0">
                      <v-list-item-subtitle class="py-1">
                        <v-row no-gutters align="center">
                          <v-col cols="6">
                            <span class="body-2 text--secondary font-weight-medium">{{newPayment.customer.name}}</span>
                          </v-col>
                          <v-col cols="6" class="pl-2">
                            <v-btn @click="dialogCustomer=true" outlined color="secondary">Seleccionar otro...</v-btn>
                          </v-col>
                        </v-row>
                        </v-list-item-subtitle>
                    </v-list-item>
                  </v-list>
                </v-list-item-subtitle>
              </v-list-item>
            </template>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="dialogCreate=false" outlined>Cancelar</v-btn>
          <v-btn @click="postPayment" :loading="$store.state.payments.createLoader" color="primary">Crear pago</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog new payment -->

    <!-- dialog customer -->
    <v-dialog v-model="dialogCustomer" width="600" persistent no-click-animation>
      <v-card>
        <v-toolbar color="transparent" flat height="60">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Seleccionar un cliente</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="pr-1">
              <v-btn icon retain-focus-on-click :ripple="false" small @click="dialogCustomer=false"><v-icon small>mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-row align="center" justify="center" no-gutters>
            <v-col cols="12" class="text-left">
              <v-col class="py-2">
                <v-text-field v-model="customerQuery" background-color="white" outlined required single-line dense placeholder="Escribe para buscar un cliente..." hide-details/>
              </v-col>
              <v-divider />
              <v-skeleton-loader v-if="$store.state.customers.retrieveLoader" :loading="$store.state.customers.retrieveLoader" type="list-item"></v-skeleton-loader>
              <template v-else>
                <template v-if="customersList.length">
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="d in customersList" :key="d.id" @click="setCustomer(d)" style="cursor: pointer">
                          <td>
                            <span class="body-1 text--secondary font-weight-medium">{{d.name}}</span>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </template>
                <v-col v-else class="text-center py-5">
                  <v-icon color="secondary" size="70">mdi-close-circle</v-icon>
                  <span class="d-block subtitle-1">No existen clientes</span>
                </v-col>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end dialog customer -->

  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, minLength, maxLength, numeric } from 'vuelidate/lib/validators'
import { paymentFilters } from '../../collections/queryBuilderFilters'

import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import VTableSettings from '@/components/VTable/VTableSettings'
import PaymentList from '@/components/payments/PaymentList'
import ListViewMixin from '@/mixins/ListViewMixin'

export default {
  components: {
    PaymentList,
    VQueryBuilder,
    VTableSettings
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    menu: false,
    newPayment: {
      customer: '',
      date: '',
      amount: null,
      currency: 'CLP',
      description: ''
    },
    collapsePayment: false,
    customerQuery: '',
    dialogCustomer: false,
    filters: paymentFilters
  }),
  computed: mapState({
    customersList: state => state.customers.customersList
  }),
  watch: {
    customerQuery () {
      this.debounceMethod(this.getCustomers)
    },
    dialogCustomer () {
      if (this.dialogCustomer) {
        this.getCustomers()
      }
    }
  },
  methods: {
    getList () {
      this.$store.dispatch('payments/LIST', {
        resource: 'payments',
        query: {
          ...this.$route.query,
          'invoice__status!': 'draft'
        }
      })
    },
    postPayment () {
      this.$v.newPayment.$touch()
      if (this.$v.newPayment.$invalid) {
        return false
      }
      const payload = Object.assign({}, this.newPayment)
      if (payload.customer) {
        payload.customer = payload.customer.id
      }
      this.$store.dispatch('payments/CREATE', {
        resource: 'payments',
        payload: payload
      })
      .then((response) => {
        this.$router.push({
          name: 'PaymentRetrieve',
          params: {
            id: response.data.id
          }
        })
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    getCustomers () {
      if ([1, 2].includes(this.customerQuery.length)) {
        return false
      }
      const query = {
        page_size: 10
      }
      if (this.customerQuery.length >= 3) {
        query.name__icontains = this.customerQuery.toLowerCase()
      }
      this.$store.dispatch('customers/LIST', {
        resource: 'customers',
        query: query
      })
    },
    setCustomer (customer) {
      this.newPayment.customer = customer
      this.customerQuery = ''
      this.dialogCustomer = false
    }
  },
  validations: {
    newPayment: {
      date: {
        required
      },
      amount: {
        required,
        numeric
      },
      description: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(256)
      }
    }
  }
}
</script>